/**
 * 所有待放行车辆(道闸)
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 所有待放行车辆
Mock.mock(/visits\/\d+\/exiting\/process\/history/, 'get' + mockSwitch, {
  'code': 0,
  'message': '',
  'data': {
    'visit_id': 1,
    'car_id': 1,
    'plate_number': '粤ABCD',
    'model_desc': 'EQ123',
    'vin': 'jdiej18302749832741',
    'history': [{
      'description': '放行审批流程被拒绝，流程发起人：张建国(**行政经理,金融保险经理,**总经理,所有权限,二手车统计,**二手车经理,奔驰二手车全部,销售经理,销售放行,市场经理,售后放行,**销售经理,**售后经理,测试,**结算会计)',
      'occured_at': '2018-03-21 15:19:20',
      'trace_type': 1,
      'src': 'https://zhongsheng.q.test.dos.cheanjia.net/api/v1/documents/qiye_image/8cGqK5SzFoBYcwugTicCAS.jpg'
    },
    {
      'description': '放行审批流程被发起，流程发起人：孔梦蝶(**行政经理,金融保险经理,**总经理,所有权限,二手车统计,**二手车经理,奔驰二手车全部,销售经理,销售放行,市场经理,售后放行,**销售经理,**售后经理,测试,**结算会计)',
      'occured_at': '2018-03-21 15:18:50',
      'trace_type': 1,
      'src': ''
    },
    {
      'description': '车辆进入【车间】（企业号登记，操作人贺强）',
      'occurred_at': '2018-08-06 10:39:00',
      'car_incoming_type': '其他',
      'trace_type': 3, // trace_type轨迹类型, 为整型, 1为进店, 2为出店, 3为进入车间, 0为其他轨迹
      'src': 'https://test-images-cdn.cheanjia.com/zhongsheng/image/v1/fdnydcinidhsalxungbqkvlskzua.jpg'
    },
    {
      'description': '车辆进入【大门】（企业号登记，操作人测试）',
      'occured_at': '2018-03-21 15:08:09',
      'src': 'https://zhongsheng.q.test.dos.cheanjia.net/api/v1/documents/qiye_image/6fiGbSyZnpp3p4CY9n3QPf.jpg'
    }]
  }
})
